import React, { Component, MouseEvent } from 'react';
import styles from './availableSizes.scss';
import Cross from '../../../../Assets/svg/cross';
import ArrowDownIcn from '../../../../Assets/svg/arrow_down';
import classNames from 'classnames';
import { IColorToAvailableSizes, ISdvColor, ISize } from '../article-tile.d';
import TabNavigationHelper from '../../../../Common/tabNavigationHelper';
import { ArticleTileContext } from '../../../globalState/articleTileContext';

export default class AvailableSizes extends Component<{
    colorsToAvailableSizes: IColorToAvailableSizes[]
    salesArticleVariantColors: ISdvColor[],
    showAvailableSizesMenu: boolean,
    dcvColorCode: number,
    toggleAvailableSizes(): void,
    notifySubscriber?(): void,
    masterArticleNo?: number
    }, 
    {needLeftRightNavigation: boolean, verticalScrollSteps: number, 
    currentVSStep: number,
    renderedColors: ISdvColor[]}>{
    static contextType = ArticleTileContext;
    
    private readonly upperSectionRef = React.createRef<HTMLDivElement>();
    private readonly centralSectionRef = React.createRef<HTMLDivElement>();
    private readonly colorsSectionRef = React.createRef<HTMLDivElement>();
    private readonly asContainerRef = React.createRef<HTMLDivElement>();
    private readonly rowPerStep = 3;
    private readonly scrollStep = 52 * this.rowPerStep; // 3 x sizeValue
    private tabNav: TabNavigationHelper;
    private imageLoadedProgress: number;

    constructor(props) {
        super(props);
        this.tabNav = TabNavigationHelper.instance;

        this.state = {
            needLeftRightNavigation: false,
            verticalScrollSteps: 0,
            currentVSStep: 1,
            renderedColors: []
        };
        
        this.handleUpDownClick = this.handleUpDownClick.bind(this);
        this.handleLeftRightClick = this.handleLeftRightClick.bind(this);
        this.imageLoadedProgress = 0;
    }

    componentDidMount(): void {
        this.getSaleTypeArticlesVariantColors();
    }

    componentDidUpdate(prevProps): void {
        if((this.props.showAvailableSizesMenu !== prevProps.showAvailableSizesMenu) 
            && this.centralSectionRef.current
            && this.upperSectionRef.current) {
            // sizes slot width width,
            // general parent container - colors column:
            if(this.centralSectionRef.current.scrollWidth 
                > (this.upperSectionRef.current.clientWidth - 55))
                this.setState({needLeftRightNavigation: true});
            else
                this.setState({needLeftRightNavigation: false});
        }

        // for mobile devices, when single component is used with different articles
        if(prevProps.masterArticleNo !== this.props.masterArticleNo) {
            this.getSaleTypeArticlesVariantColors();
        }

        if (this.asContainerRef.current) {
            if (this.props.showAvailableSizesMenu === true) {
                this.asContainerRef.current.removeAttribute('disabled')
            } else {
                this.asContainerRef.current.setAttribute('disabled', '');
            }
        }

        if ((this.props.showAvailableSizesMenu !== prevProps.showAvailableSizesMenu)
            && this.props.showAvailableSizesMenu === true) {
            // focus first size value:
            if (this.centralSectionRef.current && this.centralSectionRef.current.firstChild) {
                this.tabNav.focusToElement(undefined,
                    this.centralSectionRef.current.firstChild.firstChild as HTMLAnchorElement);
            }
        }
    }

    private getIconSrc(colorCode) {
        return `${this.context.cdnUrl}assets/ats/colors64px/Original/${colorCode}.png`
    }

    private handleLeftRightClick(left: boolean, e?: MouseEvent): void {
        if (e) {
            e.preventDefault(); //the ArticleTile has a <a>-tag to link to PDP, we want to avoid navigation here
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            e.nativeEvent.stopPropagation();

            if(this.centralSectionRef && this.centralSectionRef.current) {
                if(left)
                    this.centralSectionRef.current.scrollLeft -= this.scrollStep;
                else
                    this.centralSectionRef.current.scrollLeft += this.scrollStep;
            }
        }
    }

    private handleUpDownClick(up: boolean, e?: MouseEvent): void {
        if (e) {
            e.preventDefault(); //the ArticleTile has a <a>-tag to link to PDP, we want to avoid navigation here
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            e.nativeEvent.stopPropagation();
        }        

        if (this.centralSectionRef && this.centralSectionRef.current
            && this.colorsSectionRef && this.colorsSectionRef.current) {
            let extraScrollStep = 0;
            const verticalScrollStepsNotEqual = this.state.renderedColors.length / this.rowPerStep;

            if (up) {
                if (this.state.currentVSStep === this.state.verticalScrollSteps - 1) {                    
                    // before last step, check scroll. We have to move till the end of the container
                    verticalScrollStepsNotEqual ? extraScrollStep = 5 : extraScrollStep = 0;
                }

                this.centralSectionRef.current.scrollTop += this.scrollStep + extraScrollStep;
                this.colorsSectionRef.current.scrollTop += this.scrollStep + extraScrollStep;

                if(this.state.currentVSStep + 1 !== this.state.verticalScrollSteps)
                    this.setState({ currentVSStep: this.state.currentVSStep + 1 });
            }
            else {
                if (this.state.currentVSStep === 1) {
                    verticalScrollStepsNotEqual ? extraScrollStep = -5 : extraScrollStep = 0;
                }

                this.centralSectionRef.current.scrollTop -= this.scrollStep - extraScrollStep;
                this.colorsSectionRef.current.scrollTop -= this.scrollStep - extraScrollStep;

                if(this.state.currentVSStep !== 1)
                    this.setState({ currentVSStep: this.state.currentVSStep - 1 });
            }
        }
    }

    private getSaleTypeArticlesVariantColors(): void {
        const tmpSalesAVC: ISdvColor[] = this.props.salesArticleVariantColors.filter(it=>it.isSale === true);

        if(tmpSalesAVC && tmpSalesAVC.length > 0) {
            this.setState({
                renderedColors: tmpSalesAVC,
                verticalScrollSteps: Math.floor(tmpSalesAVC.length / this.rowPerStep),
            });
        }
        else {
            this.setState({
                renderedColors: [],
                verticalScrollSteps: 0,
            });
        }
    }

    private appendPdpLink(sizeCode: number, pdpLink: string): string {
        const parsed = new URL(pdpLink);
        parsed.searchParams.append('size', sizeCode.toString());

        return parsed.toString();
    }

    private getAvailableSizes(colorCode: number): ISize[] {
        const colorWithSizes = this.props.colorsToAvailableSizes.filter(it => it.colorCode === colorCode);

        if(colorWithSizes && colorWithSizes.length > 0) {
            return this.props.colorsToAvailableSizes.filter(it => it.colorCode === colorCode)[0].availableSizes;
        } else {
            return [];
        }
    }

    // loader works only on mobile devices:
    // availableSizesOverlayModal is a subscriber
    private handleImgLoad () {
        if (!this.props.notifySubscriber) {
            return;
        }

        this.imageLoadedProgress++;

        if (this.state.renderedColors.length === this.imageLoadedProgress) {
            // reset load process counter:
            this.imageLoadedProgress = 0;
            this.props.notifySubscriber();
        }
    }

    public render() {
        return (
            <div data-testid='available_sizes_container'
              data-semantic-id='available_sizes_container' ref={this.asContainerRef}
            className={classNames(styles.available_sizes_container,
            {[styles.show_as]: this.props.showAvailableSizesMenu}, 
            {[styles.one_color_only]: this.state.renderedColors.length === 1})}>
                <div className={styles.upper_section} ref={this.upperSectionRef}>
                    <div className={styles.colors_section} ref={this.colorsSectionRef}>
                        {this.state.renderedColors.map((sav, index) => {
                            return (<div key={index} className={classNames(styles.color_item,
                                { [styles.on_hover]: this.props.dcvColorCode === sav.color.code }
                            )}>
                                <img onLoad={this.handleImgLoad.bind(this)}
                                    className={styles.color_icon}
                                    loading='lazy'
                                    src={this.getIconSrc(sav.color.code)}
                                    title={sav.color.name} />
                            </div>)
                        })}
                    </div>
                    <div className={styles.central_section} ref={this.centralSectionRef}>
                        {
                            this.state.renderedColors.map((sav, index) => {
                                return (<div className={styles.sizes_chunk}
                                    key={index}
                                    ref={(el) => this.tabNav.setGroupAtt(el)}>
                                    {this.getAvailableSizes(sav.color.code).map((ctz, index) => {
                                        return (<a className={styles.size_value} key={index}
                                            data-size-code={ctz.sizeCode}
                                            ref={(el) => this.tabNav.setFocusAtt(el)}
                                            href={this.appendPdpLink(ctz.sizeCode, sav.pdpLink)} >
                                            <span className={styles.size_label}>{ctz.sizeLabel}</span>
                                        </a>)
                                    })}
                                </div>)
                            })
                        }
                    </div>
                    {this.props.toggleAvailableSizes !== null && // not available on mobile
                        <div className={classNames(styles.right_section,
                            { [styles.need_left_right_navigation]: this.state.needLeftRightNavigation })}
                            ref={(el) => this.tabNav.setGroupAtt(el)}>
                            <div className={classNames(styles.arrow_down, styles.arrow_left)}
                                ref={(el) => this.tabNav.setFocusAtt(el)}
                                data-testid='arrow_left'
                                data-semantic-id='arrow_left'
                                onClick={(e) => { this.handleLeftRightClick(true, e) }}
                                onKeyDown={this.tabNav.handleKeyDown}>
                                <ArrowDownIcn />
                            </div>
                            <div className={classNames(styles.arrow_down, styles.arrow_right)}
                                ref={(el) => this.tabNav.setFocusAtt(el)}
                                data-testid='arrow_right'
                                data-semantic-id='arrow_right'
                                onClick={(e) => { this.handleLeftRightClick(false, e) }}
                                onKeyDown={this.tabNav.handleKeyDown}>
                                <ArrowDownIcn />
                            </div>
                        </ div>
                    }
                </div>
                {this.props.toggleAvailableSizes !== null && // not available on mobile
                    <div className={classNames(styles.bottom_section,
                        { [styles.close_button_right]: this.state.renderedColors.length <= 4 })}
                        ref={(el) => this.tabNav.setGroupAtt(el)}>
                        <div className={classNames(styles.center_bottom_section,
                            { [styles.no_ap_down_navigation]: this.state.renderedColors.length <= 4 })}>
                            <div className={styles.arrow_down}
                                ref={(el) => this.tabNav.setFocusAtt(el)}
                                data-testid='arrow_down'
                                data-semantic-id='arrow_down'
                                onClick={(e) => { this.handleUpDownClick(true, e) }}
                                onKeyDown={this.tabNav.handleKeyDown}>
                                <ArrowDownIcn />
                            </div>
                            <div className={styles.arrow_up}
                                ref={(el) => this.tabNav.setFocusAtt(el)}
                                data-testid='arrow_up'
                                data-semantic-id='arrow_up'
                                onClick={(e) => { this.handleUpDownClick(false, e) }}
                                onKeyDown={this.tabNav.handleKeyDown}>
                                <ArrowDownIcn />
                            </div>
                        </div>
                        <div className={styles.close_button}
                            ref={(el) => this.tabNav.setFocusAtt(el)}
                            data-testid='close_button'
                            data-semantic-id='close_button'
                            onClick={this.props.toggleAvailableSizes}
                            onKeyDown={this.tabNav.handleKeyDown}>
                            <Cross />
                        </div>
                    </ div>
                }
            </div>
        );
    }
}

